import apiClient from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const submitTest = (formData: FormData) => {
  return apiClient
    .post(`${BASE_URL}/test-records/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const startAnalysis = (id: number) => {
  return apiClient
    .post(`${BASE_URL}/test-records/${id}/start_analysis/`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchTest = (id: number | string) => {
  return apiClient
    .get(`${BASE_URL}/test-records/${id}`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const fetchTestComponents = () => {
  return apiClient
    .get(`/test-records/components/?page_size=400`)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};

export const createFeedback = (
  id: number,
  is_liked: boolean,
  analysis_feedback_type?: any,
  feedback?: string
) => {
  return apiClient
    .post(`/test-records/${id}/feedback/`, {
      is_liked,
      analysis_feedback_type,
      feedback,
    })
    .then((response) => {
      return response;
    })
    .catch((err) => {
      throw err;
    });
};
